export default __webpack_public_path__ + "static/media/Internship brochure BME.3129a156.pdf";